import Shape from './Shape';
import Coords from '../Util/Coords';
import { Character, Dataset } from '../Util/Character';
import { getImageElement } from '../../../../services/resources';

const DOUBLE_PI = 2*Math.PI;
const HALF_PI = Math.PI/2;

const ANG_LEFT_FROM = 135*Math.PI/180;
const ANG_LEFT_TO = 225*Math.PI/180;
const COS_LEFT = Math.cos(ANG_LEFT_FROM);
const COS2_LEFT = Math.cos(ANG_LEFT_FROM);
const COS3_LEFT = Math.cos(Math.PI);
const SIN_LEFT = Math.sin(ANG_LEFT_TO);
const SIN2_LEFT = Math.sin(ANG_LEFT_TO);
const SIN3_LEFT = Math.sin(Math.PI);

const ANG_RIGHT_FROM = 315*Math.PI/180;
const ANG_RIGHT_TO = 45*Math.PI/180;
const COS_RIGHT = Math.cos(ANG_RIGHT_FROM);
const COS2_RIGHT = 1
const SIN_RIGHT = Math.sin(ANG_RIGHT_FROM);
const SIN2_RIGHT = 0;

const ANG_TOP_FROM = 230*Math.PI/180;
const ANG_TOP_TO = 310*Math.PI/180;
const COS_TOP = Math.cos(ANG_TOP_FROM);
const SIN_TOP = Math.sin(ANG_TOP_FROM);
const ANG_TOP_DIFF = 80*Math.PI/180;

const barOrder = [[],[0,1,2],[0,2,1],[0,1,2]];

let borderIsLoaded = false;
let imgBorder = new Image();
imgBorder.onload = ()=>{
    borderIsLoaded = true;
};
imgBorder.src = '/app/images/tkb.png';


export default class Token extends Shape {

    constructor(point) {
        super();
        this.point = point;
        this.character = new Character();
        this.image = null;
        this.imageState = '';
    }

    isToken() {
        return true;
    }

    export() {
        return {
            id: this.id,
            type: 'token',
            layer: this.layer,
            point: this.point,
            props: this.props.export('token'),
        }
    }

    updateProp(key, value) {
        if (key === 'point') {
            this.point = value;
        }
    }

    setTokenData(charlist) {
        let character = charlist.filter(i => i.id === this.props.token);
        
        let isOk = Boolean(character.length);
        if (!isOk) {
            return false;
        }

        let c = character[0];

        let dataset = new Dataset(c.dataset);
        this.character = new Character(c, dataset);

        (async () => {
            try {
                let img = await getImageElement(this.character.avatar);
                this.image = img.object;
                this.imageState = img.state;
            } catch(e) {
                this.image = null;
                this.imageState = '';
            }
        })();

        // TODO: Fazer melhoria de performance. Dá pra fazer cálculos pesados aqui
        //console.log('update values for token');

        return true;
    }

    move(x,y) {
        this.updateProp('point', [this.point[0] + x, this.point[1] + y]);
    }

    getPlayerOwner() {
        return this.character.player;
    }

    isHover (point) {
        let a = Math.abs(point[0] - this.point[0]);
        let b = Math.abs(point[1] - this.point[1]);
        let rx =Math.pow(this.character.dataset.sizeX * 0.45, 2);
        let ry = Math.pow(this.character.dataset.sizeY * 0.45, 2);

        if (((a*a/rx) + (b*b/ry)) <= 1) {
            return this.id;
        }

        return false;
    }

    isUnderSelection(bounds) {
        let p1 = [this.point[0]-this.character.dataset.sizeX*0.45, this.point[1]+this.character.dataset.sizeY*0.45];
        let p2 = [this.point[0]-this.character.dataset.sizeX*0.45, this.point[1]+this.character.dataset.sizeY*0.45];
        return Coords.inRect(p1, bounds) && Coords.inRect(p2, bounds);
    }

    isHoverPoint(p, props) {
        return false;
    }

    getMoveableProps() {
        return [this.point];
    }

    relativeMove(point, origin, initialState) {
        let dx = point[0] - origin[0];
        let dy = point[1] - origin[1];

        this.updateProp('point', [initialState[0][0] + dx, initialState[0][1] + dy]);
    }

    /*drawLegacy(props) {
        let p = Coords.toView(this.point, props.viewCenter, props.lookingAt, props.tileSize);
        let radius = props.tileSize * (0.45 * (props.gridType === 'hexagon' ? 0.8 : 1 ));

        let limitX = this.character.dataset.sizeX * radius;
        let limitY = this.character.dataset.sizeY * radius;

        this.ctx.fillStyle = '#fff';

        this.ctx.beginPath();
        this.ctx.ellipse(p[0], p[1], limitX, limitY, 0, 0, 6.283185307179586);

        if (this.imageState === 'ok') {
            this.ctx.save();
            this.ctx.clip();
            this.ctx.drawImage(this.image, 0, 0, this.image.width, this.image.height, p[0]-limitX, p[1]-limitY, limitX*2, limitY*2);
            this.ctx.restore();
        } else {
            this.ctx.stroke();
            this.ctx.fill();
        }

        // Draw circle
        if (props.selectedChar === this.character.id) {
            this.ctx.strokeStyle = '#fc0';
            this.ctx.lineWidth = 3;
            this.ctx.beginPath();
            this.ctx.ellipse(p[0], p[1], limitX, limitY, 0, 0, 6.283185307179586);
            this.ctx.stroke();
            this.ctx.closePath();
        } else if (!props.hover) {
            this.ctx.strokeStyle = '#fff';
            this.ctx.lineWidth = 3;
        } else {
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = 6;
            this.ctx.beginPath();
            this.ctx.ellipse(p[0], p[1], limitX, limitY, 0, 0, 6.283185307179586);
            this.ctx.stroke();
            this.ctx.closePath();
        }

        let distanceUnit = props.tileSize/70;

        // Draw name
        this.ctx.strokeStyle = "black";
        this.ctx.fillStyle = props.selectedChar === this.character.id ? "#fc0" : "white";
        this.ctx.lineWidth = 3;
        this.ctx.textAlign = "center";
        this.ctx.font = (18 * distanceUnit)+'px sans-serif';
        this.ctx.strokeText(this.character.name, p[0], p[1] - limitY + 5);
        this.ctx.fillText(this.character.name, p[0], p[1] - limitY + 5);

        

        let redBar = this.character.dataset.redVisibility;
        let greenBar = this.character.dataset.greenVisibility;
        let blueBar = this.character.dataset.blueVisibility;
        let numOfBars = (redBar ? 1 : 0) + (greenBar ? 1 : 0) + (blueBar ? 1 : 0);
        let barVerticalPos = limitY - 4*distanceUnit*numOfBars - 2*distanceUnit*(numOfBars-1);

        // Draw Red Bar
        this.ctx.strokeStyle = "black";
        this.ctx.lineWidth = 3;
        this.ctx.font = (10 * distanceUnit) + 'px sans-serif';

        if (redBar) {
            this.ctx.strokeRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#000";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#f44";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, (radius*this.character.dataset.redValue) << 1 , 8*distanceUnit);

            if (redBar === 'value') {
                this.ctx.fillStyle = "#fff";
                this.ctx.fillText(this.character.dataset.redView, p[0], p[1]+barVerticalPos+8*distanceUnit);
            }

            barVerticalPos += 12*distanceUnit;
        }

        // Draw Green Bar
        if (greenBar) {
            this.ctx.strokeRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#000";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#0a0";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, (radius*this.character.dataset.greenValue) << 1 , 8*distanceUnit);

            if (greenBar === 'value') {
                this.ctx.fillStyle = "#fff";
                this.ctx.fillText(this.character.dataset.greenView, p[0], p[1]+barVerticalPos+8*distanceUnit);
            }

            barVerticalPos += 12*distanceUnit;
        }

        // Draw Blue Bar
        if (blueBar) {
            this.ctx.strokeRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#000";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#27b";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, (radius*this.character.dataset.blueValue) << 1 , 8*distanceUnit);

            if (blueBar === 'value') {
                this.ctx.fillStyle = "#fff";
                this.ctx.fillText(this.character.dataset.blueView, p[0], p[1]+barVerticalPos+8*distanceUnit);
            }
        }
    }*/

    renderBar(p, width, height, pos, color, value) {
        let gradient = null;
        let angleFrom = 0;
        let angleTo = 0;
        let cosAngle = 0;
        let sinAngle = 0;
        let modifyFrom = 0;
        let modifyTo = 1;
        let angleDiff = 0;

        switch(color) {
            case 0:
                gradient = this.ctx.createLinearGradient(p[0], p[1]-height, p[0], p[1]+height);
                gradient.addColorStop(0, "#f44");
                gradient.addColorStop(1, "#600");
                break;
            case 1:
                gradient = this.ctx.createLinearGradient(p[0], p[1]-height, p[0], p[1]+height);
                gradient.addColorStop(0, "#27b");
                gradient.addColorStop(1, "#048");
                break;
            default:
                if (pos <= 1) {
                    gradient = this.ctx.createLinearGradient(p[0], p[1]-height, p[0], p[1]+height);
                } else {
                    gradient = this.ctx.createLinearGradient(p[0]+width, p[1], p[0]-width, p[1]);
                }
                gradient.addColorStop(0, "#0c0");
                gradient.addColorStop(1, "#040");
        }

        switch(pos) {
            case 0:
                angleFrom = ANG_LEFT_FROM;
                angleTo = ANG_LEFT_TO;
                cosAngle = COS_LEFT;
                sinAngle = -SIN_LEFT;
                modifyFrom = 0;
                modifyTo = 1;
                angleDiff = HALF_PI;
                break;
            case 1:
                angleFrom = ANG_RIGHT_FROM;
                angleTo = ANG_RIGHT_TO;
                cosAngle = COS_RIGHT;
                sinAngle = SIN_RIGHT;
                modifyFrom = 1;
                modifyTo = 0;
                angleDiff = HALF_PI;
                break;
            default:
                angleFrom = ANG_TOP_FROM;
                angleTo = ANG_TOP_TO;
                cosAngle = COS_TOP;
                sinAngle = SIN_TOP;
                modifyFrom = 0;
                modifyTo = 1;
                angleDiff = ANG_TOP_DIFF;
                break;
        }

        // Draw Bar
        let finalAngleFrom = angleFrom + (1-value)*modifyFrom*angleDiff;
        let finalAngleTo = (modifyTo ? angleFrom : angleTo) + value*modifyTo*angleDiff;

        finalAngleFrom = finalAngleFrom > DOUBLE_PI ? (finalAngleFrom - DOUBLE_PI) : finalAngleFrom;
        finalAngleTo = finalAngleTo > DOUBLE_PI ? (finalAngleTo - DOUBLE_PI) : finalAngleTo;

        this.ctx.strokeStyle = "#666";
        this.ctx.fillStyle = "#000";
        this.ctx.lineWidth = 3;
        this.ctx.beginPath();
            this.ctx.moveTo(p[0], p[1]);
            this.ctx.lineTo(p[0] + width*cosAngle, p[1] + height*sinAngle);
            this.ctx.ellipse(p[0], p[1], width, height, 0, angleFrom, angleTo);
            this.ctx.lineTo(p[0], p[1]);
        this.ctx.fill();
        this.ctx.stroke();

        this.ctx.fillStyle = gradient;
        this.ctx.beginPath();
            this.ctx.moveTo(p[0], p[1]);
            this.ctx.ellipse(p[0], p[1], width, height, 0, finalAngleFrom, finalAngleTo);
        this.ctx.fill();
    }

    renderBarValue(p, numBars, distanceUnit, width, height, pos, isSingleValue, index, value) {
        let x = p[0];
        let y = p[1];
        let color = "#fff";
        let fontSize = 10 * distanceUnit;

        switch(index) {
            case 0:
                color = "#f33";
                break;
            case 1:
                color = "#06f";
                break;
            default:
                color = "#0c0";
        }

        switch(pos) {
            case 0:
                x += (numBars < 3 ? COS2_LEFT : COS3_LEFT) * width;
                y += (numBars < 3 ? SIN2_LEFT : SIN3_LEFT) * height;
                break;
            case 1:
                x += (numBars < 3 ? COS_RIGHT : COS2_RIGHT) * width;
                y += (numBars < 3 ? SIN_RIGHT : SIN2_RIGHT) * height;
                break;
            default:
                y -= height;
        }

        this.ctx.lineWidth = 3;
        this.ctx.textBaseline = 'middle';
        this.ctx.textAlign = "center";
        this.ctx.font = fontSize + 'px Roboto';

        let textSize = this.ctx.measureText(value);

        this.ctx.fillStyle = "#000";
        this.ctx.lineWidth = 3*distanceUnit;
        this.ctx.strokeStyle = color;
        this.ctx.beginPath();

        if (!isSingleValue) {
            if (this.ctx.roundRect) {
                this.ctx.roundRect(x-(textSize.width/2 + 3), y-(fontSize/2 + 2), textSize.width+6, fontSize, 7 * distanceUnit);
            } else {
                this.ctx.rect(x-(textSize.width/2 + 3), y-(fontSize/2 + 2), textSize.width+6, fontSize);
            }
        } else {
            this.ctx.arc(x, y-2, fontSize, 0, DOUBLE_PI);
        }
        
        this.ctx.stroke();
        this.ctx.fill();
        
        this.ctx.strokeStyle = "#000";
        this.ctx.fillStyle = "#fff";
        this.ctx.strokeText(value, x, y);
        this.ctx.fillText(value, x, y);
    }
    
    drawTokenImage(p, limitX, limitY) {
        this.ctx.fillStyle = '#fff';
        this.ctx.beginPath();
        this.ctx.ellipse(p[0], p[1], limitX, limitY, 0, 0, 6.283185307179586);

        if (this.imageState === 'ok') {
            this.ctx.save();
            this.ctx.clip();
            this.ctx.drawImage(this.image, 0, 0, this.image.width, this.image.height, p[0]-(limitX*0.932), p[1]-(limitY*0.932), limitX*1.864, limitY*1.864);
            this.ctx.restore();
        } else {
            this.ctx.stroke();
            this.ctx.fill();
        }
    }

    drawTokenName(props, distanceUnit, p, limitY) {
        this.ctx.strokeStyle = "black";
        if (props.isOwner && this.character.hideName) {
            this.ctx.fillStyle = "rgba(255, 255, 255, 0.5)";
        } else if (props.selectedChar === this.character.id) {
            this.ctx.fillStyle = "#fc0";
        } else if (props.hover) {
            this.ctx.fillStyle = "#0ff";
        } else {
            this.ctx.fillStyle = "white";
        }
        this.ctx.lineWidth = 3;
        this.ctx.textAlign = "center";
        this.ctx.font = (16 * distanceUnit)+'px Roboto';
        this.ctx.strokeText(this.character.name, p[0], p[1] + limitY + 5);
        this.ctx.fillText(this.character.name, p[0], p[1] + limitY + 5);

    }


    drawToken(props) {
        let p = Coords.toView(this.point, props.viewCenter, props.lookingAt, props.tileSize);
        let radius = props.tileSize * (0.5 * (props.gridType === 'hexagon' ? 0.8 : 1 ));

        let distanceUnit = props.tileSize/70;

        let limitX = this.character.dataset.sizeX * radius;
        let limitY = this.character.dataset.sizeY * radius;

        let redBar = this.character.dataset.redVisibility;
        let greenBar = this.character.dataset.greenVisibility;
        let blueBar = this.character.dataset.blueVisibility;
        let numOfBars = (redBar ? 1 : 0) + (greenBar ? 1 : 0) + (blueBar ? 1 : 0);
        let barValues = [this.character.dataset.redValue, this.character.dataset.blueValue, this.character.dataset.greenValue];
        let barTexts = [this.character.dataset.redView, this.character.dataset.blueView, this.character.dataset.greenView];
        let barPositions = [-1,-1,-1];
        let barVisible = [redBar, blueBar, greenBar];
        
        let barNumber = 0;

        for (let i of barOrder[numOfBars]) {
            if (barVisible[i]) {
                if (barVisible[i] !== 'single') {
                    this.renderBar(p, limitX + (distanceUnit * 7), limitY + (distanceUnit * 7), barNumber, i, barValues[i]);
                }
                barPositions[i] = barNumber;
                barNumber++;
            }
        }

        this.drawTokenImage(p, limitX, limitY);
        if (borderIsLoaded) {
            this.ctx.drawImage(imgBorder, 0, 0, imgBorder.width, imgBorder.height, p[0]-limitX, p[1]-limitY, limitX*2, limitY*2);
        }

        // Draw circle
        if (props.selectedChar === this.character.id) {
            this.ctx.strokeStyle = '#fc0';
            this.ctx.lineWidth = props.tileSize/21;
            this.ctx.beginPath();
            this.ctx.ellipse(p[0], p[1], limitX*0.8, limitY*0.8, 0, 0, 6.283185307179586);
            this.ctx.stroke();
            this.ctx.closePath();
        } else if (props.hover) {
            this.ctx.strokeStyle = '#0ff';
            this.ctx.lineWidth = props.tileSize/21;
            this.ctx.beginPath();
            this.ctx.ellipse(p[0], p[1], limitX*0.8, limitY*0.8, 0, 0, 6.283185307179586);
            this.ctx.stroke();
            this.ctx.closePath();
        }

        if (!this.character.hideName || props.isOwner) {
            this.drawTokenName(props, distanceUnit, p, limitY);
        }

        for (let i of barOrder[numOfBars]) {
            let isSingleValue = barVisible[i] === "single";
            if (barVisible[i] === "value" || isSingleValue) {
                this.renderBarValue(p, numOfBars, distanceUnit, limitX, limitY, barPositions[i], isSingleValue, i, barTexts[i]);
            }
        }

        
        /*
        // Draw Red Bar
        this.ctx.strokeStyle = "black";
        this.ctx.lineWidth = 3;
        this.ctx.font = (10 * distanceUnit) + 'px sans-serif';

        if (redBar) {
            this.ctx.strokeRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#000";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#f44";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, (radius*this.character.dataset.redValue) << 1 , 8*distanceUnit);

            if (redBar === 'value') {
                this.ctx.fillStyle = "#fff";
                this.ctx.fillText(this.character.dataset.redView, p[0], p[1]+barVerticalPos+8*distanceUnit);
            }

            barVerticalPos += 12*distanceUnit;
        }

        // Draw Green Bar
        if (greenBar) {
            this.ctx.strokeRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#000";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#0a0";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, (radius*this.character.dataset.greenValue) << 1 , 8*distanceUnit);

            if (greenBar === 'value') {
                this.ctx.fillStyle = "#fff";
                this.ctx.fillText(this.character.dataset.greenView, p[0], p[1]+barVerticalPos+8*distanceUnit);
            }

            barVerticalPos += 12*distanceUnit;
        }

        // Draw Blue Bar
        if (blueBar) {
            this.ctx.strokeRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#000";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, radius << 1 , 8*distanceUnit);
            this.ctx.fillStyle = "#27b";
            this.ctx.fillRect(p[0]-radius, p[1]+barVerticalPos, (radius*this.character.dataset.blueValue) << 1 , 8*distanceUnit);

            if (blueBar === 'value') {
                this.ctx.fillStyle = "#fff";
                this.ctx.fillText(this.character.dataset.blueView, p[0], p[1]+barVerticalPos+8*distanceUnit);
            }
        }*/
    }



    draw(props) {
        //this.drawLegacy(props);
        this.drawToken(props);
    }

}